<template>
    <v-responsive :aspect-ratio="1/1.42" style="position:relative">
      <v-container fill-height="">
        <v-layout>

            <!-- <v-flex class="text-center" -->
              <!-- v-if="!pdfStore.available"> -->
              <!-- <v-icon x-large="">mdi-file-hidden</v-icon><br> -->
              <!-- <p>Geen document beschikbaar</p> -->
            <!-- </v-flex> -->

            <v-flex v-if="pdfStore.available">
            <v-container id="control" class="pa-3">
              <v-layout row="">
                  <v-layout class="text-center" fill-height="" justify-center="" align-center="">
                    <v-btn text icon dark @click="fullscreen = true">
                      <v-icon>mdi-fullscreen</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn icon text dark :disabled="activePage == 1">
                      <v-icon dark @click="previousPage()">mdi-chevron-left</v-icon>
                    </v-btn>
                    <span class="white--text"> {{currentPage}} / {{pageCount}}</span>
                    <v-btn text icon dark :disabled="activePage == pageCount">
                      <v-icon dark @click="nextPage()">mdi-chevron-right</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <div id="file-handler">
                      <v-btn dark text icon @click="downloadPDF()">
                        <v-icon >mdi-download</v-icon>
                      </v-btn>
                    </div>
                  </v-layout>
              </v-layout>
            </v-container>
              <div id="pdf-container">
                <v-layout justify-center="">
              <pdf 
              v-if="pdfStore.available"
                id="pdf-viewer"
                :src="pdfStore.file" 
                :page="activePage"
                @num-pages="pageCount = $event"
                @page-loaded="currentPage = $event"
              ></pdf>
              </v-layout>
            </div>
        </v-flex>
        </v-layout>
        
      </v-container>

      <v-dialog 
        id="dialog"
        fullscreen=""
        hide-overlay=""
        v-model="fullscreen" >
        <core-background></core-background>
        <v-container class="pa-3" id="dialog-control">
          <v-layout justify-end="">
            <v-icon style="padding-right:15px;" color="white" @click="downloadPDF()">mdi-download</v-icon>
            <v-icon style="padding-right:15px;" color="white" @click="fullscreen = false">mdi-close</v-icon>
          </v-layout>
        </v-container>


        <v-container style="max-width:900px">
              <div v-for="page in pageCount" :key="page">
                <pdf 
                  v-if="pdfStore.available"
                  id="pdf-viewer"
                  :src="pdfStore.file" 
                  :page="page"
                  @num-pages="pageCounter = $event"
                  @page-loaded="currentPagee = $event"
                ></pdf>
              </div>
        </v-container>
      </v-dialog>
    </v-responsive>
</template>

<script>
import { mapState } from "vuex";
import pdf from "vue-pdf";

export default {
  components: {
    pdf
  },
  data() {
    return {
      fullscreen: false,
      activePage: 1,
      pageCount: 0,
      pageCounter: 0,
      currentPagee: 1,
      currentPage: 1
    };
  },
  computed: {
    ...mapState(["pdfStore", "contract"])
  },
  methods: {
    nextPage() {
      this.activePage++;
    },
    previousPage() {
      this.activePage--;
    },
    downloadPDF() {
      var parent = document.getElementById("file-handler");
      var downloadLink = document.createElement("a");
      downloadLink.setAttribute("id", "downloadlink");
      parent.appendChild(downloadLink);

      downloadLink.download =
        this.contract.title + "-" + this.contract.subtitle + ".pdf";
      downloadLink.href = this.pdfStore.download;
      downloadLink.click();

      parent.removeChild(downloadLink);
    }
  },
  created() {
    this.$store.dispatch("getDocument");
  }
};
</script>

<style scoped>
#pdf-viewer {
  width: 100%;
  height: 100%;
  padding-right: 5%;
  padding-left: 5%;
  padding-bottom: 5%;
}
#pdf-container {
  position: relative;
  background-color: dimgrey;
  width: 100%;
  height: 100%;
}

#control {
  padding-right: 5%;
  padding-left: 5%;
  background-color: dimgrey;
}

#dialog-control {
  background-color: dimgrey;
  z-index: 2;
  border-radius: 10px;
  position: fixed;
  top: 10px;
  right: 50px;
  width: 120px;
}

#dialog {
  background-color: dimgrey;
}
</style>

